import {
  TSemanticButtonVariant,
} from './semantic-button';

type TSemanticButtonLabelMap = Record<TSemanticButtonVariant, string>;

const slovak: TSemanticButtonLabelMap = {
  accept: 'Prijať',
  add: 'Pridať',
  back: 'Späť',
  cancel: 'Zrušiť',
  close: 'Zavrieť',
  create: 'Vytvoriť',
  delete: 'Odstrániť',
  edit: 'Upraviť',
  forward: 'Dopredu',
  reset: 'Obnoviť',
  resetFilters: 'Obnoviť filtre',
  save: 'Uložiť',
  saveAsNew: 'Uložiť ako ...',
  settings: 'Nastavenia',
  tableNavigation: 'Navigácia tabuľky',
  upload: 'Nahrať',
  calculate: 'Izračunaj',
  revision: 'Revizija',
  fullscreen: 'Celá obrazovka',
  optionMenu: 'Ďalšie funkcie',
};

export default slovak;
